import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { extractMatchedPatternCode } from 'components/Admin/PatternCode';
import {
  Loading,
  ScreenMask,
  SetDefaultWarehouseDialog,
} from 'components/common';
import { LOADING_ICON_SIZE1, LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';
import { RootState } from 'reducers';
import { /*getStorage,*/ getWarehouseCodeFromCache } from 'utils';
import { SmartBackButton, SmartButton, SmartSpace } from '../SmartComponent';
import { PoRecvActionType as PRAction } from './context';

const PoReceive = () => {
  const { useState } = React;
  const [defaultWarehouseVisible, setDefaultWarehouseVisible] = useState(false);
  const [dialogClosable, setDialogClosable] = React.useState(true);
  const [enableMultiPurposeCode, setEnableMultiPurposeCode] = useState(false);
  const [inited, setInited] = useState(false);
  const [lockScreen, setLockScreen] = useState(false);
  const [profileSettingInited, setProfileSettingInited] = useState(false);

  const userProfileSettings = useSelector(
    (state: RootState) => state.admin.userProfileSettings,
    shallowEqual
  );

  const history = useHistory();

  // eslint-disable-next-line
  const gotoGuidedReceive = () => {
    history.push('/smart/poreceive/guided-recv');
  };

  const onPageBack = () => {
    //history.goBack();
    history.push('/smart');
  };

  const openSetDefaultWarehouseDialog = (config: StringKAnyVPair) => {
    setDialogClosable(
      typeof config.closable === 'boolean' ? config.closable : true
    );
    setDefaultWarehouseVisible(true);
  };

  React.useEffect(() => {
    if (!inited) {
      const whid = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (!whid || (typeof whid === 'number' && !getWarehouseCodeFromCache(whid))) {
        openSetDefaultWarehouseDialog({ closable: false });
      }

      setInited(true);
    }

    if (userProfileSettings === null) setLockScreen(true);

    if (userProfileSettings && !profileSettingInited) {
      const mpc = userProfileSettings.find(e => e.settingCode === 'EnableMultiPurpostProductCode');

      setLockScreen(false);
      setProfileSettingInited(true);

      if (mpc && mpc.settingValue === '1') {
        setEnableMultiPurposeCode(true);
      } else {
        gotoGuidedReceive();
      }
    }
  }, [gotoGuidedReceive, inited, profileSettingInited, userProfileSettings]);

  return (<>
    <SmartSpace style={{ marginTop: 40 }}>
      <Link to="/smart/poreceive/guided-recv">
        <SmartButton>
          Guided Receive
        </SmartButton>
      </Link>
      {enableMultiPurposeCode && (
        <Link to="/smart/poreceive/quick-recv">
          <SmartButton>
            Quick Receive
          </SmartButton>
        </Link>
      )}
    </SmartSpace>
    <SmartSpace>
      <SmartBackButton
        onClick={() => onPageBack()}
      />
    </SmartSpace>
    {defaultWarehouseVisible && (
      <SetDefaultWarehouseDialog
        closable={dialogClosable}
        close={() => {
          setDefaultWarehouseVisible(false);
        }}
        visible={defaultWarehouseVisible}
      />
    )}
    {lockScreen && (
      <ScreenMask>
        <Loading size={LOADING_ICON_SIZE1} />
      </ScreenMask>
    )}
  </>);
};

export default PoReceive;

export const clearMatchedPatternList = (dispatch: Function) => {
  dispatch({ type: PRAction.SetMatchedPatternList, params: [] });
};

export const extractPatternCodeList = (
  state: StringKAnyVPair,
  code: string,
) => {
  const { patternCode } = state;

  return isPatternCodeEnabled(state) ? extractMatchedPatternCode(patternCode.items, code) : undefined;
};

export const findMatchItemList = (
  recvItems: StringKAnyVPair[],
  itemCode: string,
): StringKAnyVPair[] => {
  return recvItems.filter(e => isCodeMatchLine(itemCode, e));
};

export const findMatchProductCode = (
  codeStr: string,
  prd: StringKAnyVPair,
) => {
  const code = codeStr.trim().toLowerCase();
  let ret: StringKAnyVPair | undefined = undefined;

  if (Array.isArray(prd.productCodes)) {
    ret = prd.productCodes.find((e: StringKAnyVPair) => {
      if (e && typeof e === 'object' && typeof e.code === 'string') {
        return e.code.trim().toLowerCase() === code;
      }

      return false;
    });
  }

  return ret;
};

export const getDefaultLocation = (
  state: StringKAnyVPair,
) => {
  return '';
};

export const getMatchItemBaseQty = (
  recvItems: StringKAnyVPair[],
  itemCode: string,
) => {
  return findMatchItemList(recvItems, itemCode).reduce((a, b) => a + b._baseQty, 0);
};

export const getItemReceivingMaxQty = (
  recvItems: StringKAnyVPair[],
  item: StringKAnyVPair,
) => {
  const cQty = item._receivingQty || 0;
  const nQty = getMatchItemReceivingQty(recvItems, item.sku || item.upc);
  const rQty = item.poQty - item.humanReceiveQty - (nQty - cQty);

  return rQty > 0 ? rQty : 0;
};

export const getMatchItemReceivingQty = (
  recvItems: StringKAnyVPair[],
  itemCode: string,
) => {
  return findMatchItemList(recvItems, itemCode).reduce((a, b) => a + b._receivingQty, 0);
};

export const getMatchedPatternCode = (
  patternList: StringKAnyVPair[],
  pt: string,
) => {
  const p = patternList.find((e: any) => e.type === pt && e.result === 0);

  return p ? p.value : undefined;
};

export const isCodeMatchLine = (codeStr: string, e: StringKAnyVPair) => {
  const trimCode = codeStr.trim();
  const code = trimCode.toLowerCase();

  //return (e.sku.toLowerCase() === code || e.upc.toLowerCase() === code || isCodeValid(trimCode, e.codes));
  //console.log('m->', code, e.productCodes);
  return (e.sku.toLowerCase() === code || e.upc.toLowerCase() === code || !!findMatchProductCode(code, e));
};

export const isLotAvailableOnItem = (
  state: StringKAnyVPair,
  item: StringKAnyVPair,
) => {
  //return state.enableLot;
  return state.enableLot && item.lotControl === 1;
};

export const isAnyPatternMatched = (pl: StringKAnyVPair[]) => {
  return pl.some(e => e.result === 0);
};

export const isPatternCodeEnabled = (
  state: StringKAnyVPair,
) => {
  const { patternCode } = state;

  return state.enableMultiPurposeCode && Array.isArray(patternCode.items) && patternCode.items.length > 0;
};

export const setDefaultLocation = (
  dispatch: Function,
  location: string,
) => {
  //console.log('l', location);
  dispatch({ type: PRAction.SetDefaultLocation, params: location });
};
